import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import filter from 'ramda/src/filter';
import Pagination from '@components/@core/Pagination';
import TaskEmptyList from '@components/TaskEmptyList';
import TaskHeader from '@components/@core/TaskHeader';
import TaskItem from '@components/@core/TaskItem';
import { inPage } from '~/services/util';

const Task = ({ className = '', title = '', tasks = [], placeholder = '', completed = false }) => {
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(5);
    const data = filter((e) => (completed ? !!e.completed_at : !e.completed_at), tasks);

    return (
        <div className={cx('card', className)}>
            <TaskHeader className="pb-2" title={title} />
            {data.length > 0 ? data.map((task, index) => inPage(index, page, per) && <TaskItem key={task.id} task={task} />) : <TaskEmptyList message={`There are no ${placeholder} to show`} />}
            <Pagination className="pagination px-0" current={page} per={per} pers={[]} total={Math.ceil(data.length / per)} onChange={(e) => setPage(e)} />
        </div>
    );
};

Task.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    tasks: PropTypes.array.isRequired,
    completed: PropTypes.bool,
    placeholder: PropTypes.string,
};

export default memo(Task);
